<script setup lang="ts">
import { Locale } from '~i18n/i18nConfig';

const { tt, locale } = useTypedI18n();

// EN uses € before value and dot for decimals
// NL uses € before value but comma for decimals
const euroBefore = computed(() => locale.value === Locale.EN || locale.value === Locale.NL);
const decimalDot = computed(() => locale.value === Locale.EN);
</script>

<template>
    <table class="w-full border-collapse">
        <thead>
            <tr class="bg-primary-50 text-left font-bold">
                <th class="w-1/2 p-2 align-top">{{ tt('fees.infoTable.col1.header') }}</th>
                <th class="w-1/2 p-2 align-top">{{ tt('fees.infoTable.col2.header') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr class="border-b border-solid">
                <td class="p-2 align-top">{{ tt('fees.infoTable.col1.row1') }}</td>
                <td class="p-2 align-top">
                    <BaseI18nT keypath="fees.infoTable.col2.row1">
                        <template #highlight>
                            <strong>{{ euroBefore ? '€\u00A0250' : '250\u00A0€' }}</strong>
                        </template>
                    </BaseI18nT>
                </td>
            </tr>
            <tr class="border-b border-solid">
                <td class="p-2 align-top">{{ tt('fees.infoTable.col1.row2') }}</td>
                <td class="p-2 align-top">
                    <BaseI18nT keypath="fees.infoTable.col2.row2">
                        <template #highlight>
                            <strong>{{ decimalDot ? '+\u00A08.75%' : '+\u00A08,75%' }}</strong>
                        </template>
                    </BaseI18nT>
                </td>
            </tr>
            <tr class="border-b border-solid">
                <td class="p-2 align-top">{{ tt('fees.infoTable.col1.row3') }}</td>
                <td class="p-2 align-top">
                    <BaseI18nT keypath="fees.infoTable.col2.row3">
                        <template #highlight>
                            <strong>{{ decimalDot ? '+\u00A03.75%' : '+\u00A03,75%' }}</strong>
                        </template>
                    </BaseI18nT>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr></tr>
        </tfoot>
    </table>
</template>
